import { ComponentProps, useCallback, useState } from 'react';
import classNames from 'classnames';
import './SecondaryNavItem.scss';
import { SecondaryNavSubNav } from 'app/agriculture/FarmMain/TopBar/components/SecondaryNav/SecondaryNavSubNav/SecondaryNavSubNav';
import { IconButton } from 'app/agriculture/components/Button/Button';
import { Popover } from 'app/agriculture/components/Popover/Popover';

interface SecondaryNavItemProps extends Omit<ComponentProps<typeof IconButton>, 'onClick'> {
    onClick?: () => void;
    subNavItems?: ComponentProps<typeof SecondaryNavSubNav>['items'];
}

export function SecondaryNavItem({ subNavItems, onClick, ...buttonProps }: SecondaryNavItemProps) {
    const [isOpen, setOpen] = useState(false);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const handleOpen = useCallback(() => {
        setOpen(true);
    }, []);

    if (!subNavItems || subNavItems.length === 0) {
        return (
            <IconButton
                {...buttonProps}
                onClick={() => {
                    if (!onClick) return;
                    onClick();
                }}
                key={buttonProps.tooltip}
                className={classNames('SecondaryNavItem', buttonProps.className)}
                variant="textonly"
            />
        );
    }

    return (
        <div className="SecondaryNavItem__container">
            <Popover pixelOffset={30} open={isOpen} onOpenChange={setOpen}>
                <Popover.Trigger>
                    <IconButton
                        {...buttonProps}
                        key={buttonProps.tooltip}
                        className={classNames('SecondaryNavItem', buttonProps.className, {
                            'SecondaryNavItem--open': isOpen,
                        })}
                        variant="textonly"
                        onClick={handleOpen}
                    />
                </Popover.Trigger>
                <Popover.Content disablePadding>
                    <SecondaryNavSubNav
                        items={subNavItems.map(({ onClick = () => {}, ...item }) => ({
                            ...item,
                            onClick: () => {
                                handleClose();
                                onClick();
                            },
                        }))}
                    />
                </Popover.Content>
            </Popover>
        </div>
    );
}
